import PropTypes from "prop-types";

export const Tracks = ({ caption = "" }) => {
  const renderTracks = () => {
    const tracks = [];

    if (typeof caption === "string" && caption)
      tracks.push(
        <track
          data-testid={"default-track"}
          key={"caption"}
          kind={"captions"}
          src={caption}
        />
      );
    if (typeof caption === "object") {
      Object.entries(caption).forEach(([key, value]) => {
        tracks.push(
          <track
            data-testid={"track-" + key}
            key={key}
            kind={key}
            srcLang={key}
            src={value}
          />
        );
      });
    }

    return tracks;
  };
  return <>{renderTracks()}</>;
};

Tracks.propTypes = {
  caption: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
};
